// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__4U2pV","footer":"ChangeClinic_footer__20f8B"};